import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import useDataRequesting from "../../../hooks/useDataRequesting";
import useDataFetching from "../../../hooks/useDataFetching";
import ReactToPrint from "react-to-print";
import { BlockLoading } from "../../../component/Loading";
import Print from "../../modules/print-module/Print";
import socketIOClient from "socket.io-client";
import usePuskesmas from "../../../hooks/usePuskesmas";
import BlobPrint from "view/component/BlobPrint";

const RegistrationPage = ({ puskesmas, socket }) => {
  // const puskesmas = JSON.parse(localStorage.getItem('puskesmasProfile'));
  // const socket = socketIOClient(`http://localhost:8080/${puskesmas.code}`);
  const [printData, setPrintData] = useState({});
  const [temp, setTemp] = useState({});
  const { results, error, loading } = useDataFetching({
    url: `/apm/clinics/apm/${puskesmas.code}/1/0`,
    method: "get",
  });
  const {
    results: resultsPost,
    loading: loadingPost,
    error: errorPost,
    setRequest,
  } = useDataRequesting();

  let printTriggerRef = "";
  const printRef = useRef();
  const history = useHistory();

  const print = () => {
    printTriggerRef.handlePrint();
  };

  const onClick = (data) => {
    setTemp({ clinic_name: data.clinic.name });
    setRequest({
      url: "/apm/queues/create",
      method: "post",
      data: {
        clinic_id: data.clinic_id,
        visit_id: null,
        status: false,
      },
    });
  };

  const update = () => {
    socket.emit("addQueue");
    history.push("/apm");
  };

  // useEffect(() => {
  //   return () => socket.disconnect();
  // },[]);

  useEffect(() => {
    if (Object.values(resultsPost).length)
      setPrintData({ ...resultsPost.data, ...temp });
  }, [resultsPost]);

  // useEffect(() => {
  //   if (Object.values(printData).length) print();
  // }, [printData]);

  useEffect(() => {
    if (Object.values(printData).length) {
      BlobPrint(`/apm/queues/print_reg?id=${printData.id}`);
      setTimeout(() => {
        update();
      }, 1000);
    }
  }, [printData]);

  if (loading) {
    return <BlockLoading loading={loading} />;
  }

  const { data: datas = [] } = results;

  return (
    <div className="container-fluid mt--2">
      <div className="row mb-5">
        <div className="col offset-10">
          <Link to="/apm">
            <button
              type="button"
              className="btn btn-warning btn-icon float-right"
            >
              <span className="btn-inner--icon">
                <i className="fas fa-arrow-left"></i>
              </span>
              <span className="btn-inner--text">KEMBALI</span>
            </button>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col d-flex flex-wrap justify-content-around">
          {datas.length > 0 ? (
            datas.map((data, i) => {
              return (
                <div
                  onClick={() => onClick(data)}
                  className="card mx-2"
                  style={{ width: "250px" }}
                  key={i}
                >
                  <div className="card-body text-center">
                    <h2 className="card-title display-4">{data.clinic.name}</h2>
                    <img
                      src="../assets/img/icons/health/iconfinder_Artboard_1_3872548.svg"
                      alt=""
                      width="100%"
                    />
                    <div className="card-text">{data.note}</div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="mt-9">
              <h1 className="display-2">Klinik Tidak tersedia...</h1>
            </div>
          )}
        </div>
      </div>
      <ReactToPrint
        ref={(ref) => {
          printTriggerRef = ref;
        }}
        trigger={() => <button className="d-none"></button>}
        content={() => printRef.current}
        onAfterPrint={() => {
          update();
        }}
      />
      <div className="d-none">
        <Print
          ref={printRef}
          type="pendaftaran"
          data={printData}
          puskesmasProfile={puskesmas}
        />
      </div>
    </div>
  );
};

export default usePuskesmas(RegistrationPage);
